/**
 * Dashboard Types used for creating Dashboards.
 */
const DashboardTypes = [
  {
    name: 'Details',
    key: 1
  },
  {
    name: 'Account',
    key: 2
  },
  {
    name: 'Audience',
    key: 3
  },
  {
    name: 'Macro',
    key: 4
  }
];

export default DashboardTypes;
